import { notifications } from "@mantine/notifications";

import { getMutationErrorMessage } from "@/shared/api/errors";

export async function showDiscountError(error: unknown): Promise<void> {
	notifications.show({
		color: "red",
		message: await getMutationErrorMessage(error),
	});
}
